// client_side_validations 23 + simple_form 17 under Turbo (Rails 7.2 upgrade). Required after
// rails.validations.simple_form by application.js and admin.js, and imported after the npm packages by the
// core_static pack. Globals only (jQuery, ClientSideValidations), so it works in both.
(function ($) {
  var CSV = window.ClientSideValidations
  if (!$ || !CSV) return

  // The gem's default wrapper (v16+, no jQuery) crashes on validated inputs that sit outside a wrapper
  // element, like bare f.input_field inputs (labor rate minimum billable hours). The old jQuery version
  // silently did nothing there; keep that by skipping inputs with no wrapper.
  var formBuilder = CSV.formBuilders && CSV.formBuilders['SimpleForm::FormBuilder']
  if (formBuilder && formBuilder.wrappers && formBuilder.wrappers.default) {
    const wrappers = formBuilder.wrappers
    const gemDefaultWrapper = wrappers.default
    // element is undefined when CSV 23's reset clears an input that is already gone (cocoon row removal)
    const hasWrapper = (element, settings) => element && element.closest(`${settings.wrapper_tag}.${settings.wrapper_class.replace(/ /g, '.')}`)

    wrappers.default = {
      add(element, settings, message) {
        if (hasWrapper(element, settings)) gemDefaultWrapper.add(element, settings, message)
      },
      remove(element, settings) {
        if (hasWrapper(element, settings)) gemDefaultWrapper.remove(element, settings)
      }
    }
  }

  // CSV starts on turbo:load only when Turbo is already defined as it loads. The Sprockets bundles load
  // before the pack that brings Turbo, so CSV ran on DOM ready only and the forms of pages reached by a
  // Turbo visit had no client-side validation (production loaded Turbolinks first, and CSV ran on every
  // turbolinks:load). Enable the forms of each later page here; the first page is CSV's own DOM-ready start
  // (Turbo's first turbo:load fires before DOM ready, so this listener is added after it).
  if (typeof CSV.initializeOnEvent === 'function' && CSV.initializeOnEvent() !== 'turbo:load') {
    $(function () {
      $(document).on('turbo:load', function () {
        $(CSV.selectors.forms).filter(function () { return !this.ClientSideValidations }).validate()
      })
    })
  }
})(window.jQuery)
